// src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";


import Splash from "./Splash";
import MenuExact from "./MenuExact";
import OptionsManager from "./OptionsManager";
import Login from "./login";
import UserAdmin from "./UserAdmin";

import BoisForm from "./Logistique/BoisForm";
import ResineForm from "./Logistique/ResineForm";
import Consultation from "./Logistique/Consultation"; // consultation générique
import ConsultationResine from "./Logistique/ConsultationResine"; // nouveau
import ConsultationAmorceur from "./Logistique/ConsultationAmorceur";
import ConsultationIlss from "./Logistique/ConsultationIlss";
import ConsultationColle from "./Logistique/ConsultationColle";
import ConsultationPrelevements from "./Logistique/ConsultationPrelevements";
import PlacagesDecoupes from "./Logistique/PlacagesDecoupes";
import ConsultationFlexion from "./Logistique/ConsultationFlexion";
import AmorceurForm from "./Logistique/AmorceurForm";
import ColleForm from "./Logistique/ColleForm";
import DashboardQualiteGlobale from "./Dashboard/DashboardQualiteGlobale";
 import DashboardQualiteStack from "./Dashboard/DashboardQualiteStack";
 import DashboardFlexionILSS from "./Dashboard/DashboardFlexionILSS";
// Dans le bloc imports Qualité — avec les autres imports Qulaité/
import FicheStack from "./rd/FicheStack";


import PrelevementDecoupe from "./Production/PrelevementDecoupe";
import ConformitePli from "./Production/ConformitePli";
import TracabilitePli from "./Production/TracabilitePli";
import PrelevementMelangeAmorceur from "./Production/PrelevementMelangeAmorceur";
import PrelevementSolutionResineAmorceur from "./Production/PrelevementSolutionResineAmorceur";
import RajoutMelangeResineAmorceur from "./Production/RajoutMelangeResineAmorceur";
import Impregnation from "./Production/Impregnation";
import TraitementThermique from "./Production/TraitementThermique";
import Empilement from "./Production/Empilement";
import EmpilementV2 from "./Production/EmpilementV2";
import Fabrication from "./Production/Fabrication";
import Aboutage from "./Production/Aboutage";
import LivraisonQualite from "./Production/LivraisonQualite";
import ConsultationImpregnation from "./Production/ConsultationImpregnation"
   import ConsultationConditionnement from "./Production/ConsultationConditionnement";



import FlexionForm from "./Qulaité/FlexionForm";
import ILSSForm from "./Qulaité/IlssForm";
import ControleResineForm from "./Qulaité/ControleResineForm";
import ConsultationControleResine from "./Logistique/ConsultationControleResine";
import QualiteAmorceurResineForm from "./Qulaité/QualiteAmorceurResineForm";
import QualiteBois from "./Qulaité/QualiteBois";
import ConsultationQualiteAmorceurResine from "./Qulaité/ConsultationQualiteAmorceurResine";
import ConsultationQualiteBois from "./Qulaité/ConsultationQualiteBois";
import QualiteColle from "./Qulaité/QualiteColle";
import ConsultationQualiteColle from "./Qulaité/ConsultationQualiteColle";
import ControleStack from "./Qulaité/ControleStack";
import ConsultationControleStack from "./Qulaité/ConsultationControleStack";
import QualiteStackPlaneiteForm from "./Qulaité/QualiteStackPlaneiteForm";
import ConsultationControleStackPlaneite from "./Qulaité/ConsultationControleStackPlaneite";
import TomographieStacks from "./Qulaité/TomographieStacks";
import ExportExcelQualite from "./Qulaité/ExportExcelQualite";
import DashboardTracabiliteStack from "./Dashboard/DashboardTracabiliteStack";
import DashboardLogistique from "./Dashboard/DashboardLogistique";
import DashboardProduction from "./Dashboard/DashboardProduction";
import HumiditePlisPage from "./Dashboard/HumiditePlisPage";
import DashboardMaestro from "./Dashboard/DashboardMaestro";
import DashboardMaestroThermocouples from "./Dashboard/DashboardMaestroThermocouples";
import DashboardPlacagesDensite from "./Dashboard/DashboardPlacagesDensite";
import DashboardPicoLog from "./Dashboard/DashboardPicoLog";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Menu principal */}
        <Route path="/" element={<Login />} />
        <Route path="/menu" element={<MenuExact />} />
        <Route path="/admin/users" element={<UserAdmin />} />

        {/* Suivi stock */}
        <Route path="/logistique/stock/bois" element={<Consultation />} />
        <Route path="/logistique/stock/resine" element={<ConsultationResine />}        />
        <Route path="/logistique/stock/amorceur"   element={<ConsultationAmorceur />}        />
        <Route path="/logistique/stock/colle" element={<ConsultationColle />} />
        <Route path="/logistique/prelevements" element={<ConsultationPrelevements />} />
        <Route path="/logistique/placages-decoupes" element={<PlacagesDecoupes />} />
        <Route path="/logistique/stack" element={<Consultation />} />
        {/* Réception matière */}
        <Route path="/logistique/reception/bois" element={<BoisForm />} />
        <Route path="/logistique/reception/resine" element={<ResineForm />} />
        <Route path="/logistique/reception/amorceur" element={<AmorceurForm />}        />
        <Route path="/logistique/reception/colle" element={<ColleForm />} />


        {/* Production matière */}
        <Route  path="/production/prelevement-decoupe" element={<PrelevementDecoupe />}        />
        <Route path="/production/conformite-pli" element={<ConformitePli />} />
        <Route path="/production/tracabilite-pli"   element={<TracabilitePli />}    />
        <Route path="/production/humidite-pli" element={<HumiditePlisPage />} />
        <Route   path="/production/amorceur-melange"     element={<PrelevementMelangeAmorceur />}       />
        <Route    path="/production/solution-resine-amorceur"     element={<PrelevementSolutionResineAmorceur />}        />
        <Route   path="/production/rajout-resine-amorceur" element={<RajoutMelangeResineAmorceur />}    />
        <Route path="/production/impregnation" element={<Impregnation />} />
        <Route   path="/production/traitement-thermique"        element={<TraitementThermique />}        />
        <Route path="/production/empilement" element={<Empilement />} />
        <Route path="/production/empilement-v2" element={<EmpilementV2 />} />
        <Route path="/production/fabrication" element={<Fabrication />} />
        <Route path="/production/aboutage" element={<Aboutage />} />
        <Route path="/production/livraison" element={<LivraisonQualite />} />
          <Route path ="/production/list-impregnation" element={<ConsultationImpregnation />} />
        <Route path="/production/conditionnement" element={<ConsultationConditionnement />} />



        {/* Qualité */}
        <Route    path="/qualite/controleStack/flexion"  element={<FlexionForm />}      />
        <Route path="/qualite/controleStack/ilss" element={<ILSSForm />} />
        <Route path="/qualite/controleStack/controle-resine" element={<ControleResineForm />} />
        <Route   path="/qualite/MP/amoreceur_resine"   element={<QualiteAmorceurResineForm />}        />
        <Route path="/qualite/MP/bois" element={<QualiteBois />} />
        <Route path="/qualite/MP/colle" element={<QualiteColle />} />
        <Route path="/qualite/controleStack" element={<ControleStack />} />
        {/*<Route path="/qualite/controleStackPlaneite" element={<QualiteStackPlaneiteForm/>} />*/}
        <Route  path="/qualite/MP/suivi_amoreceur_resine"  element={<ConsultationQualiteAmorceurResine />}        />
        <Route  path="/qualite/MP/suivi_bois"  element={<ConsultationQualiteBois />}   />
        <Route   path="/qualite/MP/suivi_colle"   element={<ConsultationQualiteColle />}  />
        <Route  path="/qualite/MP/suivi_controlstack"  element={<ConsultationControleStack />}   />
        <Route  path="/qualite/suivi_controlstack_planeite"  element={<ConsultationControleStackPlaneite />}  />
        <Route  path="/qualite/controleStack_planeite"  element={<QualiteStackPlaneiteForm />} />
        <Route   path="/qualite/Stack/flexion" element={<ConsultationFlexion />} />
        <Route path="/qualite/Stack/ilss" element={<ConsultationIlss />} />
        <Route path="/qualite/Stack/controle-resine" element={<ConsultationControleResine />} />
        <Route path="/qualite/Stack/tomographie" element={<TomographieStacks />} />
        <Route path="/qualite/export-excel" element={<ExportExcelQualite />} />

          <Route path="/rd/Stack/fiche"            element={<FicheStack />} />


         {/* Dashboard */}
          <Route path="/dashboard/qualite" element={<DashboardQualiteGlobale />} />

          <Route path="/dashboard/qualite/stack" element={<DashboardQualiteStack />} />
          <Route path="/dashboard/qualite/flexion-ilss" element={<DashboardFlexionILSS />} />
          <Route path="/dashboard/qualite/tracabilite" element={<DashboardTracabiliteStack />} />
          <Route path="/dashboard/qualite/placages-densite" element={<DashboardPlacagesDensite />} />
          <Route path="/dashboard/logistique" element={<DashboardLogistique />} />
           <Route path="/dashboard/production" element={<DashboardProduction />} />
          <Route path="/dashboard/maestro" element={<DashboardMaestro />} />
          <Route path="/dashboard/maestro/thermocouples" element={<DashboardMaestroThermocouples />} />
          <Route path="/dashboard/picolog" element={<DashboardPicoLog />} />


        {/* Divers */}
        <Route path="/" element={<Splash />} />
        <Route path="/form" element={<BoisForm />} />
        <Route path="/consultation" element={<Consultation />} />
        <Route path="/options/:type" element={<OptionsManager />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
